import React, { useEffect, useState } from 'react';
import { ResponsiveLine } from '@nivo/line';

import { ChartWidget } from 'itaf';

import SpedService from '../../../services/SpedService';

const month = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul","Ago","Set","Out","Nov","Dez"];

function getMonth(sdate) {
  const date = new Date(sdate);
  date.setDate(date.getDate() + 1);
  return date.getMonth();
}

function getYear(sdate) {
  const date = new Date(sdate);
  date.setDate(date.getDate() + 1);
  return date.toLocaleDateString('pt-BR', { year : '2-digit'});
}

export default function LineWidget({ onFullScreen }) {
  const [data, setDashboardSelic] = useState(null);
  const [isLoading, setLoading] = useState(true);

  const title = "Taxa Selic dos últimos 12 meses";
  
  useEffect(() => {
    loadDashboardSelic();
  }, []);
  
  function loadDashboardSelic() {
    setLoading(true);
    SpedService.fetchSelic()
    .then(async (res) => {
      if (res.ok) {
        const body = await res.json();
          const data = [];
          body.map((item) => {
            data.push({ x: `${item.dtfim}`, y: item.selic });
          });
          const dat = [{ data: [ ...data ], id: "selic", }];
          setDashboardSelic(dat);
        }
      })
      .finally(setLoading(false));
  }

  const tooltip = ({ slice}) => {
    const valueX = slice?.points[0].data?.x;
    const valueY = slice?.points[0].data?.y || 0;
    return (
    <div style={{
      background: 'white', 
      color: 'inherit',
      fontSize: 'inherit',
      borderRadius: '2px', 
      boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 2px',
      padding: '5px 9px'}}
    >
      <div style={{
        whiteSpace: 'pre', display: 'flex', alignItems: 'center',
      }}>
        <span style={{
          display: 'block', width: '12px', height: '12px', 
          background: slice?.points[0].seriesColor, marginRight: '7px' }}
        />
        <strong>
          Selic {month[getMonth(valueX)] + "/" + getYear(valueX)} ({Math.abs(valueY)})
        </strong>
      </div>
    </div>
  )};

  if (!data && !isLoading) {
    return (<div></div>);
  }

  return (
    <ChartWidget title={title}
      isLoading={isLoading}
      onFullScreen={onFullScreen}>
      <ResponsiveLine
        data={data}
        margin={{ top: 24, right: 32, bottom: 48, left: 32 }}
        animate={true}
        enableSlices='x'
        colors={{ scheme: 'paired' }}
        xScale={{
          type: 'time',
          format: '%Y-%m-%d',
          useUTC: false,
          precision: 'month',
        }}
        xFormat="time:%Y-%m-%d"
        yScale={{
          type: 'linear',
          min: 'auto',
          max: 'auto',
        }}
        yFormat=" >-.2f"
        axisTop={null}
        axisRight={null}
        axisBottom={{
          orient: 'bottom',
          format: function(value) {
            const date = new Date(value);
            return month[(date.getMonth())] + " " + value.toLocaleDateString('pt-BR', { year : '2-digit'});
          },
          tickSize: 10,
          tickPadding: 5,
          legend: 'Meses',
          legendOffset: 42,
          legendPosition: 'middle',
        }}
        axisLeft={null}
        enablePointLabel={true}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabelYOffset={-12}
        useMesh={true}
        sliceTooltip={tooltip}
        legends={[]}
      />
    </ChartWidget>
  );
}
